
import { ControlElement } from '@jsonforms/core';
import { rendererProps, RendererProps, useJsonFormsEnumControl } from '@jsonforms/vue';
import { defineComponent } from 'vue';
import emitter from 'tiny-emitter/instance';

const controlRenderer = defineComponent({
  name: 'enum-control-renderer',
  components: {},
  props: {
    ...rendererProps<ControlElement>(),
  },
  setup(props: RendererProps<ControlElement>) {
    return useJsonFormsEnumControl(props);
  },
  data() {
    return {
      disable: false,
      filteredOptions: [] as any[],
      search: '',
      isTouched: false,
    };
  },
  mounted() {
    if (
      this.control?.data?.length &&
      !this.control?.uischema?.options?.editable &&
      !this.control?.config?.editableHydratedFields
    ) {
      this.disable = true;
    }
    if (!this.control.data && this.control.uischema.options?.default) {
      this.control.data = this.control.uischema.options.default;
      this.onChange(this.control.data);
    }
  },
  computed: {
    requiredRules() {
      return this.control.required ? [this.requiredRule] : [];
    },
    options() {
      const key: any =
        this.control.uischema.options && this.control.uischema.options.key ? this.control.uischema.options.key : null;
      const options: any[] = [];
      this.control?.options?.forEach((item: any) => {
        if (
          this.control.uischema.options &&
          this.control.uischema.options.disabledOptions &&
          this.control.uischema.options.disabledOptions.includes(item.value)
        ) {
          item.disable = true;
        }
        options.push(item);
      });
      return options;
    },
  },
  created() {
    emitter.on('setDestinationApmId', (apmId: string) => {
      if (this.control?.uischema?.options?.key === 'destinationApmId') {
        this.isTouched = true;
        this.onChange(apmId);
      }
    });
    emitter.on('setSourceApmId', (apmId: string) => {
      if (this.control?.uischema?.options?.key === 'sourceApmId') {
        this.isTouched = true;
        this.onChange(apmId);
      }
    });
  },
  methods: {
    requiredRule(value: any) {
      if (!this.control.required) return true;
      return value !== null && value !== undefined && value !== '' ? true : 'Value must be selected';
    },
    onBlur() {
      this.isTouched = true;
    },
    onFocus() {
      // Optionally mark as touched on focus
    },
    filterFn(val: any, update: any) {
      if (val === '') {
        update(() => {
          this.filteredOptions = this.options;
        });
        return;
      }
      update(() => {
        const needle = val.toLowerCase();
        this.filteredOptions = this.options.filter(
          (v) => v.label.toLowerCase().indexOf(needle) > -1 || v?.value.toLowerCase().indexOf(needle) > -1,
        );
      });
    },
    onChange(value: any) {
      this.isTouched = true;
      this.handleChange(this.control.path, value == null ? '' : value);
    },
  },
});

export default controlRenderer;
